import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const search: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M7.969-3.031C8.656-3.72 9-4.54 9-5.5a3.34 3.34 0 0 0-1.031-2.469A3.34 3.34 0 0 0 5.5-9Q4.062-9 3.031-7.969A3.34 3.34 0 0 0 2-5.5c0 .961.344 1.781 1.031 2.469C3.72-2.344 4.54-2 5.5-2a3.34 3.34 0 0 0 2.469-1.031M13 1c0 .27-.102.504-.297.703A.98.98 0 0 1 12 2a.94.94 0 0 1-.703-.297L8.625-.969A5.37 5.37 0 0 1 5.5 0a5.4 5.4 0 0 1-2.14-.437A5.42 5.42 0 0 1 .437-3.36 5.4 5.4 0 0 1 0-5.5c0-.75.145-1.46.438-2.14q.434-1.013 1.171-1.75.732-.75 1.75-1.172a5.47 5.47 0 0 1 4.282 0 5.3 5.3 0 0 1 1.75 1.171q.75.739 1.172 1.75.435 1.018.437 2.141a5.3 5.3 0 0 1-.969 3.11L12.72.296A.98.98 0 0 1 13 1m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "13",
    width: "13",
  }
};
